import { actionsPreprocessor } from '@/utils/redux';

const actionNames = [
  'CREATE_QUOTE',
  'CREATE_QUOTE_SUCCESS',
  'CREATE_QUOTE_FAILED',

  'CREATE_PACE_QUOTE',
  'CREATE_PACE_QUOTE_SUCCESS',
  'CREATE_PACE_QUOTE_FAILED',

  'GENERATE_PROPOSAL',
  'GENERATE_PROPOSAL_SUCCESS',
  'GENERATE_PROPOSAL_FAILED',

  'SET_PROPOSAL_ACTIVE',
  'SET_PROPOSAL_ACTIVE_SUCCESS',
  'SET_PROPOSAL_ACTIVE_FAILED',

  'REQUEST_PROPOSAL',
  'REQUEST_PROPOSAL_SUCCESS',
  'REQUEST_PROPOSAL_FAILED',

  'SET_LOADING_PERCENT',
  'SHOW_QUOTES_PREVALIDATE_MESSAGES',
  'REMOVE_QUOTES_PREVALIDATE_MESSAGE',
  'CLEAR_QUOTES_PREVALIDATE_MESSAGES',

  'UNLOCK_REQUESTED_PROPOSAL',
  'UNLOCK_REQUESTED_PROPOSAL_SUCCESS',
  'UNLOCK_REQUESTED_PROPOSAL_FAILED',
];

const { actions, actionTypes } = actionsPreprocessor('quotes', actionNames);

export default actions;
export { actionTypes };
